import { createSettingsUsersService } from "api-client";

const path =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || "";

export const settingsUsersService = createSettingsUsersService(path);
